import { observable, computed, makeObservable } from 'mobx';
import {DomainObject} from 'shared/store';
import Employee from 'main/stores/employees/Employee';
import CompanyDocument from 'main/stores/documents/CompanyDocument';
import {calendarDate} from 'shared/tools';

class DocumentAction extends DomainObject {
  id;
  createdAt;
  actionedAt;
  dueDate;

  employee;
  companyDocumentParent;
  companyDocument;

  _relations = {
    employee: Employee,
    companyDocumentParent: CompanyDocument,
    companyDocument: CompanyDocument,
    _dates: ['actionedAt']
  };

  constructor(other) {
    super();

    makeObservable(this, {
      id: observable,
      createdAt: observable,
      actionedAt: observable,
      dueDate: observable,
      employee: observable,
      companyDocumentParent: observable,
      companyDocument: observable,
      formattedDueDate: computed
    });

    this.merge(other);
  }

  get formattedDueDate() {
    return calendarDate(this.dueDate);
  }
}

export default DocumentAction;
